module.exports = __webpack_public_path__ + "img/pro-zdTicon15.e70650bc.png";